<script>
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import {contacts, requisites} from "@js/company_details.ts";

export default {
    name: "PrivacyPolicyPage",
    components: {MobileTopBar, Breadcrumbs},
    setup() {
        return {contacts, requisites};
    }
}
</script>

<template>
    <MobileTopBar/>

    <div class="container">
        <Breadcrumbs class="mb-2"/>

        <h1 class="text-2xl md:text-3xl">Политика конфиденциальности ООО «ФУЛЛ СТРОЙ»</h1>
        <p class="text-sm text-gray-600 mt-2">Действует для сайта full-stroy.ru</p>

        <hr class="mt-5 mb-5"/>

        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5 font-medium">1. Общие положения</h2>

            <p class="text-sm mb-2">
                Настоящая Политика конфиденциальности определяет порядок обработки и защиты персональных данных
                пользователей сайта <strong>full-stroy.ru</strong>, оператором которого является
                <strong>ООО «ФУЛЛ СТРОЙ»</strong>.
            </p>

            <p class="text-sm mb-2">
                Оператор обрабатывает персональные данные в соответствии с законодательством Российской Федерации,
                включая Федеральный закон № 152-ФЗ «О персональных данных».
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5 font-medium">2. Какие данные мы обрабатываем</h2>

            <p class="text-sm mb-2">
                К персональным данным могут относиться: имя, телефон, электронная почта, адрес доставки, реквизиты
                организации, сведения о заказе, данные об оплате, история обращений, а также иная информация, которую
                пользователь добровольно передаёт через формы сайта, по телефону, электронной почте или в мессенджерах.
            </p>

            <p class="text-sm mb-2">
                Также сайт может автоматически получать технические данные: IP-адрес, данные браузера и устройства,
                дату и время посещения, просмотренные страницы, источник перехода на сайт.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5 font-medium">3. Цели обработки персональных данных</h2>

            <ul class="list-disc pl-6 text-sm space-y-2">
                <li>приём и обработка заявок на строительные материалы;</li>
                <li>подготовка коммерческих предложений, счетов, договоров и закрывающих документов;</li>
                <li>согласование наличия, стоимости, условий оплаты, доставки и разгрузки;</li>
                <li>организация поставки ЖБИ, бетона, пиломатериалов, тротуарной плитки, нерудных материалов и строительных конструкций;</li>
                <li>обработка обращений, претензий и запросов покупателей;</li>
                <li>информирование о статусе заказа;</li>
                <li>ведение бухгалтерского, налогового и управленческого учёта;</li>
                <li>улучшение работы сайта, аналитика посещаемости и качества сервиса;</li>
                <li>обеспечение безопасности сайта и предотвращение недобросовестных действий.</li>
            </ul>
        </div>

        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5 font-medium">4. Правовые основания обработки</h2>

            <p class="text-sm mb-2">
                Обработка персональных данных осуществляется на основании согласия пользователя, необходимости
                исполнения договора или подготовки договора по инициативе пользователя, требований законодательства РФ,
                а также законных интересов Оператора, если это не нарушает права и свободы пользователя.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5 font-medium">5. Cookies и технические данные</h2>

            <p class="text-sm mb-2">
                Сайт использует cookies и аналогичные технологии для корректной работы, аналитики, сохранения
                пользовательских настроек и улучшения качества сервиса.
            </p>

            <p class="text-sm mb-2">
                Пользователь может ограничить или отключить cookies в настройках браузера. В этом случае отдельные
                функции сайта могут работать некорректно.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5 font-medium">6. Сервисы аналитики и рекламы</h2>

            <p class="text-sm mb-2">
                На сайте могут использоваться сервисы веб-аналитики, рекламы и обратной связи, включая Яндекс.Метрику,
                рекламные кабинеты, формы связи, мессенджеры и иные технические сервисы. Такие сервисы могут обрабатывать
                обезличенные технические данные и cookies по собственным правилам.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5 font-medium">7. Хранение персональных данных</h2>

            <p class="text-sm mb-2">
                Персональные данные хранятся не дольше, чем этого требуют цели обработки, условия договора или
                требования законодательства РФ. После достижения целей обработки данные удаляются, обезличиваются или
                архивируются, если дальнейшее хранение обязательно по закону.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5 font-medium">8. Передача данных третьим лицам</h2>

            <p class="text-sm mb-2">
                Оператор может передавать данные транспортным компаниям, поставщикам, платёжным организациям, банкам,
                сервисам связи, хостинг-провайдерам, бухгалтерским и юридическим подрядчикам только в объёме,
                необходимом для исполнения заказа, договора или требований закона.
            </p>

            <p class="text-sm mb-2">
                Передача данных для иных целей допускается только при наличии согласия пользователя либо другого
                законного основания.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5 font-medium">9. Права пользователя</h2>

            <p class="text-sm mb-2">
                Пользователь вправе получить сведения об обработке своих персональных данных, потребовать их уточнения,
                блокирования или удаления, отозвать согласие на обработку, а также обжаловать действия Оператора в
                уполномоченный орган или суд.
            </p>

            <p class="text-sm mb-2">
                Для обращения по вопросам персональных данных используйте адрес:
                <strong>{{ contacts.info_mail }}</strong>.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5 font-medium">10. Данные несовершеннолетних</h2>

            <p class="text-sm mb-2">
                Сайт не предназначен для самостоятельного использования несовершеннолетними. Если стало известно, что
                несовершеннолетний передал данные без согласия законного представителя, свяжитесь с нами для удаления
                такой информации.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5 font-medium">11. Ссылки на сторонние сайты</h2>

            <p class="text-sm mb-2">
                На сайте могут размещаться ссылки на сторонние ресурсы. Оператор не отвечает за содержание таких
                ресурсов и порядок обработки данных на них.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5 font-medium">12. Изменение Политики</h2>

            <p class="text-sm mb-2">
                Оператор вправе изменять настоящую Политику. Актуальная редакция всегда размещается на этой странице.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5 font-medium">13. Контакты оператора</h2>

            <p class="text-sm mb-2">
                Оператор: <strong>ООО «ФУЛЛ СТРОЙ»</strong><br>
                ИНН: <strong>{{ requisites.inn }}</strong><br>
                КПП: <strong>{{ requisites.kpp }}</strong><br>
                ОГРН: <strong>{{ requisites.ogrn }}</strong><br>
                Юридический адрес: <strong>{{ requisites.ur_address }}</strong><br>
                Сайт: <strong>full-stroy.ru</strong><br>
                E-mail: <strong>{{ contacts.info_mail }}</strong>
            </p>
        </div>
    </div>
</template>

<style scoped lang="scss">
</style>
